import StatusIcon from '@components/icons/status-icon'
import { TAlert, TIncident } from '@core/modules/mdr/cases'
import { formatDate } from '@core/utils/time'
import { NoteItem } from '@ui/drawer/common/noteItem'
import {
    Title,
    Content,
    Flex,
    Circle,
    Status,
    NoRelatedCases,
} from './caseTabRelatedCases.styles'

interface Props {
    caseData: TAlert | TIncident
    currentTab: 'alerts' | 'incidents'
}

const CaseTabRelatedCases = ({ caseData, currentTab }: Props) => {
    const hasChildAlerts =
        Array.isArray(caseData?.childAlerts) && caseData.childAlerts.length > 0
    return (
        <Content data-testid="detection-content">
            <Title variant="s-bold">
                {currentTab === 'alerts' ? 'Parent Incident' : 'Child Alerts'}
            </Title>
            {hasChildAlerts ? (
                caseData.childAlerts.map(
                    ({ severity, title, lastModifiedAt, status }) => (
                        <NoteItem title={''} key={title}>
                            <Flex>
                                <div className="icon">
                                    <StatusIcon
                                        status={
                                            severity?.toLowerCase() as
                                                | TIssueSeverity
                                                | TIssueStatus
                                        }
                                        height="12px"
                                    />
                                </div>
                                <Title
                                    variant="xs-bold"
                                    testId="case-title"
                                    component="span"
                                    className="text"
                                    noWrap={false}
                                >
                                    {title}
                                </Title>
                            </Flex>
                            <Flex>
                                <Title
                                    variant="xs-regular"
                                    testId="case-title"
                                    component="span"
                                    className="text"
                                    noWrap={false}
                                >
                                    <Status value={status as string}>
                                        {status}
                                    </Status>
                                </Title>
                                <Circle />
                                <Title
                                    variant="xs-regular"
                                    testId="case-title"
                                    component="span"
                                    className="text"
                                    noWrap={false}
                                >
                                    Last modified:{' '}
                                    {formatDate(lastModifiedAt as string)}
                                </Title>
                            </Flex>
                        </NoteItem>
                    )
                )
            ) : (
                <NoRelatedCases variant="s-regular">N\A</NoRelatedCases>
            )}
        </Content>
    )
}

export default CaseTabRelatedCases
